//vendor imports
import $ from 'jquery';
import _ from 'ext:lodash';
import Omnibox from 'components/Omnibox';
import constants from "lib/constants";

let global = {};

export default class HeaderNav {
	constructor(config) {
		this.config = config;

		this.state = {
			breakpoints: []
		};
	}

	setState(newState) {
		_.assign(this.state, newState);
	}

	initialize(globalDom) {
		global = $(globalDom);
		this.$el = $(this.config.locateAClubEl);
		this.locateAClubOmnibox = this.$el.find(this.config.locateAClubOmnibox);

		this.omnibox = new Omnibox(this.locateAClubOmnibox);
		this.omnibox.initialize({type: constants.clubSearchSource.omniboxBlueBanner});
	};
}
